import React from 'react' // eslint-disable-line

import styled from 'styled-components'
import SALink from 'components/SALink'
import { OwnerInfoSection as OwnerInfo } from 'styles/algolia/user/header'
import { Column, Row } from 'styles/general'
export const MasonryWidth = 250
export const gridRowGap = 0
export const gridColumnGap = 60
export const gridAutoRows = 25
export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
`
export const Break = styled.div`
  flex-basis: 100%;
  height: 0;
`
export const Header = styled(HeaderRow)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-wrap: wrap;
  border-bottom: 1px solid #eeeeee;
  margin: 0px;
  padding-bottom: 24px;
`
export const Thumbline = styled(Row)`
  margin-top: 10px;
  @media (max-width: 600px) {
    margin-top: 5px;
  }
`
export const Thumb = styled.div`
  display: inline-flex;
  width: 31.5%;
  height: 100px;
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-position: center center;
  &:last-child {
    padding-right: 0;
  }
  @media (max-width: 350px) {
    height: 43px;
  }
  @media (min-width: 351px) and (max-width: 600px) {
    height: 51px;
  }
`
export const TitleBanner = styled(Column)`
  text-align: center;
  font-size: 24px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.2);
  height: 100%;
  span {
    display: block;
    padding: 0 10px;
  }
  [data-type='title'] {
    margin-top: 115px;
  }
  [data-type='description'] {
    display: none;
  }
  [data-type='newThisWeekTitle'] {
    font-size: 16px;
  }
  [data-type='newThisWeekDate'] {
    margin-top: 5px;
    font-size: 24px;
  }
  [data-type='newThisWeekCount'] {
    margin-top: 5px;
    font-size: 18px;
  }
  @media (max-width: 1024px) {
    [data-type='newThisWeekTitle'] {
      font-size: 16px;
    }
    [data-type='newThisWeekDate'] {
      font-size: 24px;
    }
    [data-type='newThisWeekCount'] {
      font-size: 18px;
    }
  }
  @media (max-width: 600px) {
    font-size: 16px;
    [data-type='title'] {
      margin-top: 61px;
      @media (max-width: 350px) {
        margin-top: 50px;
      }
    }
  }
  @media (min-width: 600px) and (max-width: 768px) {
    [data-type='newThisWeekTitle'] {
      font-size: 16px;
    }
    [data-type='newThisWeekDate'] {
      font-size: 24px;
    }
    [data-type='newThisWeekCount'] {
      font-size: 18px;
    }
  }
`
export const ThumbOverlay = styled(Column)`
  background-color: rgba(255, 255, 255, 0.95);
  display: inline-flex;
  width: 100%;
  height: 100px;
  background-size: cover;
  background-position: center center;
  &:last-child {
    padding-right: 0;
  }
`
export const Layout = styled(Column)`
  max-width: 1440px;
  padding: 0 16px;
  margin: 0 auto;
  @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
    overflow-x: hidden;
  }
  ${Header} {
    justify-content: center;
    h1,
    p {
      width: 100%;
    }
    @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
      align-items: flex-start;
    }
    ${Row} {
      align-items: center;
      justify-content: space-betweeen;
      @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
        flex-direction: column;
      }
    }
    }
  }
`
export const CollectionImage = styled.div`
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 300px;
  max-width: 100%;
  max-height: 300px;
  display: block;
  pointer-events: none;
  @media (max-width: 350px) {
    height: 138px;
  }
  @media (min-width: 351px) and (max-width: 600px) {
    height: 164px;
  }
`
export const ArtworkContent = styled(Column)`
  position: relative;
  a {
    text-decoration: none;
    ${ThumbOverlay} {
      display: none;
    }
    @media (min-width: 1024px) {
      &:hover {
        ${Thumbline} {
          ${ThumbOverlay} {
            display: block;
          }
        }
        ${CollectionImage} {
          ${TitleBanner} {
            @media (max-width: 600px) {
              [data-type='description'] {
                display: none;
              }
            }
            [data-type='description'] {
              display: block;
              text-align: center;
              margin-top: 16px;
              color: #333;
              font-size: 16px;
            }
            span {
              color: #333;
            }
            background-color: rgba(255, 255, 255, 0.95);
          }
        }
      }
    }
  }
`
export const ArtworkItem = styled.div`
  display: flex;
  &:focus,
  > :focus {
    outline: none;
  }
  &:before {
    display: block;
    height: 0;
    width: 0;
    padding-bottom: calc(9 / 16 * 100%);
  }
`
export const ArtworksList = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-template-rows: 1fr;
  grid-column-gap: 63px;
  grid-row-gap: 49px;
  @media (max-width: 600px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-column-gap: 15px;
    grid-row-gap: 24px;
  }
`
export const NewThisWeekList = styled.div`
  width: 100%;
  display: grid;
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  div:nth-child(1) {
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 3;
  }

  @media (max-width: 665px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 665px) and (max-width: 768px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    div:nth-child(1) {
      grid-column-start: 1;
      grid-column-end: 5;
    }
  }
`
export const NewThisWeekItem = styled.div`
  display: flex;
  &:focus,
  > :focus {
    outline: none;
  }
  &:before {
    display: block;
    height: 0;
    width: 0;
    padding-bottom: calc(9 / 16 * 100%);
  }
`
export const NewThisWeekImage = styled.div`
  background-image: url(${(props) => props.image});
  background-size: cover;
  height: 274px;
  width: 100%;
  background-position: center center;
  display: block;
  pointer-events: none;
  min-height: 80px; /* We set the min-height using ASPECT RATIO */
  @media (max-width: 350px) {
    height: 142px;
  }
  @media (min-width: 351px) and (max-width: 600px) {
    height: 169px;
  }
  @media (min-width: 600px) and (max-width: 768px) {
    height: 150px;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    height: 200px;
  }
`
export const NewThisWeekArtworkContent = styled(Column)`
  position: relative;
  a {
    text-decoration: none;
    color: ${(props) => props.theme.colors.default};
    ${TitleBanner} {
      justify-content: center;
    }
    [data-type='firstArtWorkItem'] {
      ${TitleBanner} {
        justify-content: center;
        [data-type='newThisWeekTitle'] {
          font-size: 18px;
        }
        [data-type='newThisWeekDate'] {
          margin-top: 5px;
          font-size: 36px;
        }
        [data-type='newThisWeekCount'] {
          margin-top: 5px;
          font-size: 24px;
        }
      }
      height: 553px;
      @media (max-width: 350px) {
        height: 290px;
      }
      @media (min-width: 351px) and (max-width: 600px) {
        height: 343px;
      }
      @media (min-width: 600px) and (max-width: 768px) {
        height: 343px;
      }
      @media (min-width: 768px) and (max-width: 1024px) {
        height: 405px;
      }
    }
  }
`
export const OwnerAvatar = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  @media (max-width: 600px) {
    width: 24px;
    height: 24px;
  }
`
export const InfoColumn = styled(Column)``
export const CuratorName = styled(SALink)`
  color: #1e1e1e;
`
export const ArtistRole = styled.p`
  margin-top: -18px;
  font-size: 14px;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: normal;
  color: #333;
  @media (max-width: 600px) {
    font-size: 10px;
  }
`
export const InfoRow = styled(Row)`
  display: flex;
  width: auto;
  justify-content: center;
  align-items: center;
  gap: 16px;
  a {
    text-decoration: none;
  }
`
export const OwnerInfoSection = styled(OwnerInfo)`
  width: auto;
  margin-top: 24px;
  &&& ${InfoRow} {
    @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
      flex-direction: row;
      align-items: flex-start;
    }
    [data-style='curator-info-text-container'] {
      display: flex;
      flex-direction: column;
      gap: 4px;
      @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
        gap: 0px;
      }
    }
    [data-type='featured-section-curator-name'] {
      margin-top: 41px;
      font-size: 14px;
      white-space: nowrap;
    }
    [data-type='featured-section-curator-job'] {
      font-size: 14px;
    }
    [data-type='featured-section-curator-avatar'] {
      width: 44px;
      height: 44px;
      margin-top: 36px;
    }
    @media (max-width: 600px) {
      [data-type='featured-section-curator-name'] {
        margin-top: 15px;
        font-size: 14px;
        white-space: nowrap;
      }
      [data-type='featured-section-curator-avatar'] {
        margin-top: 10px;
      }
    }
  }
`
export const LoadMoreButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 64px;
`
export const LoadMoreButton = styled(SALink)`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${(props) => props.theme.fontSizes[2]}px;
  color: ${(props) => props.theme.colors.default};
  border: 1px solid #333;
  font-size: 16px;
  width: 165px;
  height: 44px;
  cursor: pointer;
  padding: 10px 15px;
`
export const Button = styled(SALink)`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #de3900;
  cursor: pointer;
  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    font-size: ${(props) => props.theme.fontSizes[3]}px;
  }
`
